import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode } from '@angular/core';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { APP_PROVIDERS } from './app/app.providers';
import { provideRouter, withPreloading } from '@angular/router';
import { routes } from './app/app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { PreloadAllModules } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { importProvidersFrom } from '@angular/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ClipboardModule } from 'ngx-clipboard';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAnalyticsModule } from '@angular/fire/compat/analytics';
import { MATERIAL_COMPONENTS } from './app/app.material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    // Angular core providers
    importProvidersFrom(
      BrowserModule,
      HttpClientModule,
      ReactiveFormsModule,
      FormsModule,
      InfiniteScrollModule,
      NgCircleProgressModule.forRoot(),
      ClipboardModule,
      AngularFireModule.initializeApp(environment.firebase),
      AngularFireAnalyticsModule
    ),
    
    // Animations
    provideAnimations(),
    
    // Routing
    provideRouter(routes, withPreloading(PreloadAllModules)),
    
    // Custom providers
    ...APP_PROVIDERS,
    
    // Material modules as importProviders
    importProvidersFrom(...MATERIAL_COMPONENTS as any),
  ]
}).catch(err => console.error(err));
